const ProgressBar = ({ currentStep, totalSteps, onBack }) => {
  return (
    <div className="progress-bar">
      <button className="progress-bar__back" onClick={onBack} />
      <div className="progress-bar__bar">
        <div
          className="progress-bar__bar__progress"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
